type TLike = (key: string, opts?: Record<string, unknown>) => string;

interface Input {
  carrierName: string;
  ruleName?: string;
}

interface BannerText {
  title: string;
  changeLink: string;
}

/**
 * RS-23 — build the auto-dispatch transparency banner copy (PRD §8.5).
 *
 * Two flavours:
 *   - With rule name: "Auto-assigned to Hi-Express by rule Baghdad → Small."
 *   - Without:        "Auto-assigned to Hi-Express."
 *
 * The "Change carrier" link copy comes from the same key namespace so
 * RTL/Arabic gets full coverage from the i18n files.
 */
export function buildAutoDispatchBannerText(input: Input, t: TLike): BannerText {
  const ruleName = input.ruleName?.trim();
  const titleKey = ruleName
    ? 'shipping_rules.auto_dispatch.title'
    : 'shipping_rules.auto_dispatch.title_no_rule_name';

  return {
    title: t(titleKey, { carrier: input.carrierName, rule: ruleName ?? '' }),
    changeLink: t('shipping_rules.auto_dispatch.change_link'),
  };
}
